import React from "react";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";

const DetailTrimestre = ({ InfosTrimestres }) => {
  return (
    <Column fill>
      <CardBox>
        <Column fill>
          <Row>
            <div className="revenuspro-container">
              {/* Header séparé */}
              <div className="header-card">
                <div className="category-column" style={{ textAlign: "center", maxWidth: "120px" }}>Année</div>
                <div className="value-column" style={{ textAlign: "center" }}>Régime unifié</div>
                <div className="value-column" style={{ textAlign: "center" }}>Trimestres assimilés</div>
                <div className="value-column" style={{ textAlign: "center" }}>Cnavpl</div>
                <div className="value-column" style={{ textAlign: "center" }}>Cnbf</div>
                <div className="value-column" style={{ textAlign: "center" }}>Msa</div>
                <div className="value-column" style={{ textAlign: "center" }}>Fonction publique</div>
                <div className="value-column" style={{ textAlign: "center" }}>CRPCEN</div>
                <div className="value-column" style={{ textAlign: "center" }}>Trimestres retenus</div>
              </div>

              {/* Conteneur des cartes de contenu */}
              <div className="card-list-container">
                {Object.entries(InfosTrimestres.Trimestre).map((data, index) => {
                  return (
                    <div key={"DetailTrimestre" + index} className="card">
                      <div className="category-column" style={{maxWidth: "120px"}}>
                        <span className="trimester-year-badge">{data[0]}</span>
                      </div>
                      <div className="value-column">
                        {data[1]["RegimeUnifie"]["TrimestreRetenu"] > 0 ? data[1]["RegimeUnifie"]["TrimestreRetenu"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1]["RegimeAssimile"]["TrimestreRetenu"] > 0 ? data[1]["RegimeAssimile"]["TrimestreRetenu"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1]["RegimeCnavpl"]["TrimestreRetenu"] > 0 ? data[1]["RegimeCnavpl"]["TrimestreRetenu"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1]["RegimeCnbf"]["TrimestreRetenu"] > 0 ? data[1]["RegimeCnbf"]["TrimestreRetenu"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1]["RegimeMsa"]["TrimestreRetenu"] > 0 ? data[1]["RegimeMsa"]["TrimestreRetenu"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1]["FonctionPublique"]["TrimestreRetenu"] > 0 ? data[1]["FonctionPublique"]["TrimestreRetenu"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1]["Crpcen"]["TrimestreRetenu"] > 0 ? data[1]["Crpcen"]["TrimestreRetenu"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1].TrimestreCotisesToutRegime}
                      </div>
                    </div>
                  );
                })}
                
                {/* Carte récapitulative Total */}
                <div className="card" style={{ backgroundColor: "#f3f4f6", fontWeight: "600" }}>
                  <div className="category-column" style={{ fontWeight: "600", textAlign: "center", maxWidth: "120px" }}>
                    <span>Total</span>
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {InfosTrimestres.TotalTrimestreRegimeUnifie}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {InfosTrimestres.TotalTrimestreRegimeAssimile}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {InfosTrimestres.TotalTrimestreRegimeCnavpl}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {InfosTrimestres.TotalTrimestreRegimeCnbf}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {InfosTrimestres.TotalTrimestreRegimeMsa}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {InfosTrimestres.TotalTrimestreFonctionPublique}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {InfosTrimestres.TotalTrimestreCrpcen}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {Number(
                      Number(InfosTrimestres["InfosRetraite"]["General"]["TotalTrimestre"]) -
                        Number(InfosTrimestres.TotalTrimestreMajorationEnfant) -
                        Number(InfosTrimestres.TrimestreMajorationAgeRegimeUnifie)
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailTrimestre;

//    <FormatLignePension
//   key={index++}
//   caisse={"RSI Commerçant"}
//   points={data[1]["General"]["TotalPoint"]}
//   valeurPoint={data[1]["General"]["ValeurPoint"]}
//   pensionTheo={data[1]["General"]["PensionTheorique"]}
//   coeff={data[1]["General"]["Coefficient"]}
//   majoEnfant={"-"}
//   pension={data[1]["General"]["Pension"]}
// />
